const SalesforceManage = () => import('@/views/account/integrations/salesforce/salesforce-manage-view');
const SalesforceConnect = () => import('@/views/account/integrations/salesforce/salesforce-connect-view');
const SalesforceAuthenticationSuccess = () => import('@/views/account/integrations/salesforce/salesforce-authentication-success');

import store from '@/stores/index';

import SalesforceMappingRoutes from '@/routes/integrations/salesforce/mapping';
import SalesforceImportRoutes from '@/routes/integrations/salesforce/import';

export default [
    {
        path: '/Integrations/Salesforce/Manage',
        name: 'Salesforce Manage',
        component: SalesforceManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Salesforce Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage',
        name: 'Client Salesforce Manage',
        component: SalesforceManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Salesforce Integration'
        }
    },
    {
        path: '/Integrations/Salesforce/Manage/Connection',
        name: 'Salesforce Connect',
        component: SalesforceConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Salesforce Connection'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage/Connection',
        name: 'Client Salesforce Connect',
        component: SalesforceConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Salesforce Connection'
        }
    },
    {
        path: '/Integrations/Salesforce/AuthenticationSuccess',
        name: 'Authentication Success',
        component: SalesforceAuthenticationSuccess,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Authentication Success'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    ...SalesforceMappingRoutes,
    ...SalesforceImportRoutes
]